module.exports = __webpack_public_path__ + "img/38.8.TSS.71b2743f.png";